// Client mirror of the lock-value codec (server/filterExpression.js). The server
// owns the Looker syntax; the suite editor needs the same reading of a stored
// lock string so the chips it shows are the values that will actually be sent.
// Keep the two in sync — test/filterValues.test.js asserts they agree.
//
// Why it exists: values are comma-separated in a lock, so an event named
// "DJ Kent, Ready D & Will Linley at Cabo Beach" came back as TWO chips and was
// sent to Looker (where `,` means OR) as two events that don't exist. A comma
// inside a value is stored escaped as `^,` — Looker's own escape character, so
// the stored string is already what Looker should receive.
//
// A `^` that isn't escaping a comma or a caret is a literal caret, so existing
// values are read exactly as they always were.
const ESCAPABLE = /[,^]/;

// Raw lock string → the values a human picked, decoded.
export function splitValues(v) {
  const s = String(v == null ? '' : v);
  const out = []; let cur = '';
  for (let i = 0; i < s.length; i += 1) {
    const c = s[i];
    if (c === '^' && ESCAPABLE.test(s[i + 1] || '')) { cur += s[i + 1]; i += 1; continue; }
    if (c === ',') { out.push(cur); cur = ''; continue; }
    cur += c;
  }
  out.push(cur);
  return out.map((x) => x.trim()).filter(Boolean);
}

export const escapeValue = (v) => String(v == null ? '' : v).replace(/[,^]/g, (c) => `^${c}`);

// Values → the raw lock string. The inverse of splitValues.
export const joinValues = (vals) => (Array.isArray(vals) ? vals : splitValues(vals))
  .map((v) => escapeValue(String(v).trim())).filter(Boolean).join(',');
